module.exports = __webpack_public_path__ + "img/img-asuth-sideimg.38a94742.png";